import moment from 'moment';


export function range(start, stop, step) {
  step = step || 1;
  let list = [];
  for (var i = start; i < stop; i = i + step) {
    list.push(i);
  }
  return list;
}

// https://stackoverflow.com/a/3866442/979377
export function setEndOfContenteditable(contentEditableElement) {
  var range, selection;
  if(document.createRange)
  {
    range = document.createRange();
    range.selectNodeContents(contentEditableElement);
    range.collapse(false);
    selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }
  else if(document.selection)
  {
    range = document.body.createTextRange();
    range.moveToElementText(contentEditableElement);
    range.collapse(false);
    range.select();
  }
}

// https://stackoverflow.com/a/2117523/979377
export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function shortId() {
  return Math.random().toString(36).substr(2, 10);
}


export function localeWeekdayIndicesMonToFri() {
  // return the weekday indices from Mon to Fri in the current locale
  let list = [];
  let mondayToFriday = moment.weekdays().slice(1, 6);
  let localeWeekdays = moment.weekdays(true);
  for (var i = 0; i < 7; i += 1) {
    if (mondayToFriday.includes(localeWeekdays[i])) {
      list.push(i);
    }
  }
  return list;
}
